import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Order } from '@us/web/shared/data-access';
import { ORDER_QRCODE_PREFIX } from '@us/web/shared/utils';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
    selector: 'us-order-qrcode',
    template: `
        <qrcode [qrdata]="qrcodeStr" [width]="width" [errorCorrectionLevel]="'M'" class="inline-block"></qrcode>
    `,
    styles: [``],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [QRCodeModule]
})
export class OrderQrcodeComponent implements OnInit {
    @Input() order!: Order;
    @Input() width = 200; // 256

    qrcodeStr = '';

    ngOnInit(): void {
        this.qrcodeStr = ORDER_QRCODE_PREFIX + this.order.order_id;
    }
}
